import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import './Layout.css'

const Layout = ({ children, className }) => {
  return (
    <div className={`g-layout-wrap ${className ? className : ''}`}>
      <Scrollbars className="g-scroll">
        {children}
      </Scrollbars>
    </div>
  )
}

export default Layout
